import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { FORCE_PROF_UI } from '@/constants/common';
import { useCommonStore } from '@/store';
import { useRefreshAccount } from '@/hooks/account';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const setSuccessfulRegistrationModalOpen = useCommonStore(
    (s) => s.setSuccessfulRegistrationModalOpen
  );
  const { mutateAsync: refreshAccount } = useRefreshAccount();

  const isItProfPlan = useMemo(() => !!FORCE_PROF_UI, []);

  useEffect(() => {
    refreshAccount(undefined).then(() => {
      setSuccessfulRegistrationModalOpen(true);
      if (isItProfPlan) {
        navigate('/clients');
      } else {
        navigate('/start');
      }
    });
  }, [
    isItProfPlan,
    navigate,
    refreshAccount,
    setSuccessfulRegistrationModalOpen,
  ]);

  return null;
};

export default SubscriptionSuccess;
